module.exports = __webpack_public_path__ + "static/media/bedroom2.4e969d4f.jpg";